import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class StatisticsService {
  static async findAll(params?: Record<string, any>) {
    const data = await api.get(endpoints.statistics, { params });
    return data;
  }
}
